import { computed, reactive } from 'vue';
import { normalizeScreens } from './normalizeScreens';
import buildMediaQuery from './buildMediaQuery';
import defaultScreens from './defaultScreens';
import { windowHasFeature } from './window';
export const defaultInjectKey = '$screens';
export function initScreens(screens) {
    const state = reactive({
        screens: normalizeScreens(screens || defaultScreens),
        queries: {},
        matches: {},
        hasSetup: false,
    });
    function refreshMatches() {
        Object.entries(state.queries).forEach(([key, query]) => {
            state.matches[key] = query.matches;
        });
    }
    function mapList(config) {
        return computed(() => Object.keys(state.matches)
            .filter((key) => state.matches[key] === true && config.hasOwnProperty(key))
            .map((key) => config[key]));
    }
    const list = computed(() => Object.keys(state.matches).filter((k) => state.matches[k]));
    function mapCurrent(config, def) {
        return computed(() => {
            const curr = current.value;
            if (curr && config.hasOwnProperty(curr))
                return config[curr];
            return def;
        });
    }
    const current = computed(() => {
        const arr = list.value;
        if (arr.length)
            return arr[arr.length - 1];
        return '';
    });
    function cleanup() {
        Object.values(state.queries).forEach((query) => query.removeEventListener('change', refreshMatches));
        state.queries = {};
        state.matches = {};
    }
    if (!state.hasSetup && windowHasFeature('matchMedia')) {
        cleanup();
        state.queries = state.screens.reduce((result, { name, values }) => {
            const mediaQuery = window.matchMedia(buildMediaQuery(values));
            mediaQuery.addEventListener('change', refreshMatches);
            result[name] = mediaQuery;
            return result;
        }, {});
        refreshMatches();
        state.hasSetup = true;
    }
    return { matches: state.matches, list, mapList, current, mapCurrent, cleanup };
}
//# sourceMappingURL=initScreens.js.map